import styles from '../Navigation.module.scss'
import NavigationItem from '../navigation-item/NavigationItem.tsx'
import { useTranslation } from 'react-i18next'
import { routes } from 'types/routes.ts'
import { SalesNavigationProps } from 'layouts/components/navigation/types.ts'

const BottomSalesNavigation = ({ handleLogout }: SalesNavigationProps) => {
  // i18n
  const { t } = useTranslation()

  return (
    <nav className={styles['bottom-navigation']} aria-labelledby="main">
      <ul className={styles['nav-items-list']}>
        <NavigationItem icon="homeSmileOutline" activeIcon="homeSmile" text={t(($) => $.nav.overview)} url={routes.SALES_HOME} />
        <NavigationItem icon="fileOutline" activeIcon="file" text={t(($) => $.nav.events)} url={routes.SALES_EVENTS} />
        <NavigationItem icon="logOut" text={t(($) => $.nav.logout)} onClick={handleLogout} id="logout" />
      </ul>
    </nav>
  )
}

export default BottomSalesNavigation
